import { siteContent } from '../data/content'

interface TestimonialProps {
  product?: 'wms' | 'psa'
}

export default function Testimonial({ product = 'wms' }: TestimonialProps) {
  const testimonial = siteContent.testimonials.find(
    (t) => t.product === product && t.status === 'live'
  )
  if (!testimonial) return null

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <svg className="w-12 h-12 text-navy-200 mx-auto mb-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
          </svg>

          <blockquote className="text-2xl md:text-3xl font-medium text-navy-900 leading-relaxed">
            "{testimonial.quote}"
          </blockquote>

          <div className="mt-8">
            <div className="font-semibold text-navy-900">{testimonial.author}</div>
            <div className="text-navy-600">{testimonial.role}, {testimonial.company}</div>
          </div>
        </div>
      </div>
    </section>
  )
}
